import miniToastr from 'mini-toastr'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
const message = miniToastr.init({ types: toastTypes })
export default {
  message
}



// WEBPACK FOOTER //
// ./src/components/toastPlugin/index.js